




















import { Component, Prop, Vue } from 'vue-property-decorator'
import { LocaleMessage } from 'vue-i18n'

export interface ItemLink {
  label: string|LocaleMessage
  url: string
}

export interface Item {
  date: string|LocaleMessage
  title: string
  description: string|LocaleMessage
  links?: ItemLink[]
}

@Component({
  name: 'Timeline'
})
export default class Timeline extends Vue {
  $mq: any
  showLine: boolean
  delays: number[]
  lineAnimDuration: number

  @Prop({ default: () => [] })
  items!: Item[]

  constructor () {
    super()
    this.showLine = false
    this.delays = []
    this.lineAnimDuration = 0
  }

  mounted () {
    this.delays = new Array(this.items.length).fill(300)
  }

  get lineStyle () {
    return {
      height: this.showLine && this.items && this.items.length ? '100%' : '0',
      gridRow: `1 / ${this.items.length + 2}`,
      transitionDuration: `${this.lineAnimDuration}s`
    }
  }

  get itemClasses () {
    return (i: number): string => {
      let side = i % 2 ? 'left' : 'right'
      if (this.$mq === 'phone' || this.$mq === 'tablet-portrait') {
        side = 'right'
      }
      const visible = this.delays[i] === 0 ? 'visible' : ''
      return `${side} ${visible}`
    }
  }

  resetDelays () {
    this.delays.fill(300)
    this.showLine = false
    this.lineAnimDuration = 0
  }

  revealItems () {
    const items = this.items ? this.items.length : 0
    this.lineAnimDuration = 0.3 * (items + 2)
    let sum = 0
    this.showLine = true
    let j = 0
    for (const i in this.items) {
      sum += this.delays[i]
      setTimeout(() => {
        Vue.set(this.delays, i, 0)
      }, sum)
    }
  }

  visibilityChanged (isVisible: boolean, entry: any) {
    if (isVisible) {
      this.revealItems()
    } else if (entry.boundingClientRect.top >= 0) {
      this.resetDelays()
    }
  }
}
